import React from "react";
import {Typography} from "@mui/material";


// @ts-ignore
const Headline = ({text}) => <Typography variant="h5" component="h2">{text}</Typography>;

export default Headline;